export default __webpack_public_path__ + "static/prop-ombuds-white-ab30c1aff67283a1694f160fb3626c44.svg";